import { Component, OnInit } from '@angular/core';
import * as pbi from 'powerbi-client';
import { FilterGD, SourcePowerBIEnum } from 'src/app/interfaces/models/filter-item.model';
import { FiltersGeneralDashboardModel } from 'src/app/interfaces/models/filters-general-dashboard.model';
import { Data } from 'src/app/interfaces/Responses/IPBITokenInfoResponse';
import { SharedService } from 'src/app/services/dashboards/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'neoris-total-country-dashboard',
  templateUrl: './total-country-dashboard.component.html',
  styleUrls: ['./total-country-dashboard.component.css']
})
export class TotalCountryDashboardComponent implements OnInit {

  public screenHeight: number;
  desktopView: MediaQueryList = matchMedia('(min-width: 1280px)')
  _site: string;
  currentFormat: string = '1'
  descargado: boolean = false
  type: string
  dashboardTypeId: string = '1104'
  businessUnitId: string = '1'
  lastUpdate: string
  report: any
  filtersGeneralDashboardModel: FiltersGeneralDashboardModel

  constructor(private sharedService: SharedService) { }

  async ngOnInit(): Promise<void> {

    this.type = '64'
    this._site = localStorage.getItem('site')
    this.screenHeight = (window.screen.height);
    this.desktopView.addEventListener('change', this.changeSize)
    let data = await this.getConfigurationReport(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
    localStorage.setItem('config-current-report', JSON.stringify(data.data))
    let configReport = localStorage.getItem('config-current-report')
    this.showReport(JSON.parse(configReport))
    setInterval(async () => {
      let data = await this.getConfigurationReport(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
      localStorage.setItem('config-current-report', JSON.stringify(data.data))
      let configReport = localStorage.getItem('config-current-report')
      this.showReport(JSON.parse(configReport))
      document.getElementById('message-update').style.display = 'block'
      let today = new Date()
      this.lastUpdate = today.toLocaleString()
    }, 5 * 60 * 60 * 1000)
  }

  async getConfigurationReport(_site: string, type: string, dashboardTypeId: string, businessUnitId: string): Promise<any> {

    return this.sharedService.getPBITokenInfo(this._site, type, dashboardTypeId, businessUnitId).toPromise()
  }

  changeFormat(format: string) {
    this.currentFormat = format
  }

  async ReloadDashboard() {
    const pages = await this.report.getPages()
    const page = pages.find(p => p.isActive)
    const visuals = await page.getVisuals()
    const filters = await visuals.filter(t => t.title !== undefined && t.type === 'slicer')
    await this.setFilters(filters)
    this.descargado = true
    this.sharedService.getExportStream(this._site, '4', this.currentFormat, this.dashboardTypeId, this.businessUnitId, this.filtersGeneralDashboardModel, SourcePowerBIEnum.PED).subscribe((response) => {
      this.showFile(response)
      this.descargado = false
    })
  }

  async setFilters(filters: any): Promise<void> {
    const year = await filters.filter(f => f.title === FilterGD.Year)
    const month = await filters.filter(f => f.title === FilterGD.Month)
    const day = await filters.filter(f => f.title === FilterGD.Day)
    const filteryear = await year[0].getSlicerState()
    const filtermonth = await month[0].getSlicerState()
    const filterday = await day[0].getSlicerState()

    this.filtersGeneralDashboardModel = {
      filters: [
        {
          target: filteryear.filters[0]?.target,
          operator: filteryear.filters[0]?.operator,
          values: filteryear.filters[0]?.values
        },
        {
          target: filtermonth.filters[0]?.target,
          operator: filtermonth.filters[0]?.operator,
          values: filtermonth.filters[0]?.values
        },
        {
          target: filterday.filters[0]?.target,
          operator: filterday.filters[0]?.operator,
          values: filterday.filters[0]?.values
        }
      ]
    }
    this.filtersGeneralDashboardModel.filters = this.filtersGeneralDashboardModel.filters.filter(f => f.values != null && f.target != null)
  }

  showFile(blob: Blob) {
    let newBlob = blob
    const data = window.URL.createObjectURL(newBlob);
    let link = document.createElement('a');
    link.href = data;
    switch (this.currentFormat) {
      case '1':
        link.download = "TotalCountry.pdf";
        break;
      case '2':
        link.download = "TotalCountry.pptx";
        break;
    }
    link.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  changeSize(mql) {
    mql.matches ?
      this.sharedService.getPBITokenInfo(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
        .subscribe((response) => {
          let data = response.data
          this.showReport(data);
        }) :
      this.sharedService.getPBITokenInfo(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
        .subscribe((response) => {
          let data = response.data
          this.showReport2(data);
        })
  }

  showReport2(data) {
    let embedUrl = data.embedReport[0].embedUrl
    let embedReportId = data.embedReport[0].reportId
    let config = {
      type: 'report',
      tokenType: 1,
      accessToken: data.embedToken.token,
      embedUrl: embedUrl,
      id: embedReportId,
      settings: {
        layoutType: 2,
        panes: {
          filters: {
            visible: false
          },
          pageNavigation: {
            visible: false
          }
        }
      }
    };
    let reportContainer = document.getElementById('totalcountry')
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    let report = powerbi.embed(reportContainer, config);
    report.off("loaded");
    report.on("loaded", () => {
    });
    report.on("error", (e) => {
      console.log(e)
    });
  }

  async showReport(data: Data) {
    let models = pbi.models
    let permissions = models.Permissions.Read
    let loadedResolve, reportLoaded = new Promise((res, rej) => { loadedResolve = res })
    let renderedResolve, reportRendered = new Promise((res, rej) => { renderedResolve = res })
    let embedUrl = data.embedReport[0].embedUrl
    let embedReportId = data.embedReport[0].reportId
    let reportContainer = <HTMLElement>document.getElementById('totalcountry')
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    powerbi.reset(reportContainer)
    let config = {
      type: 'report',
      tokenType: models.TokenType.Embed,
      accessToken: data.embedToken.token,
      embedUrl: embedUrl,
      id: embedReportId,
      permissions: permissions,
      viewMode: models.ViewMode.View,
      settings: {
        layoutType: models.LayoutType.Master,
        bars: {
          actionBar: { visible: false }
        },
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: false },
          bookmarks: { visible: false }
        }
      }
    }
    try {
      this.report = <pbi.Report>powerbi.embed(reportContainer, config) as pbi.Visual
      this.report.off("loaded")
      this.report.on("loaded", () => {
        const filter = {
          $schema: environment.urlPowerBI,
          target: {
            table: "BIG_TABLE_EFFICIENCY",
            column: "ID_FACILITY"
          },
          operator: "In",
          values: [localStorage.getItem('site')],
          filterType: 1,
          requireSingleSelection: true
        }
        this.report.setFilters([filter]).then(res => {
          this.report.getFilters().then(filters => {
          });
        }).catch((error: any) => {
          console.error(error);
        });
        loadedResolve()
        this.report.off("loaded")
      })
      this.report.off("error")
      this.report.on("error", (e) => {
        console.log('error showReport', e.detail)
        this.changeSize(this.desktopView)
      })
      this.report.off("rendered")
      this.report.on("rendered", function () {
        renderedResolve()
      })
    } catch (error) {
      console.log("error gd tc showReport => ", error)
    }

    await reportLoaded

    await reportRendered
  }

}
